<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
    @close="closeHandler()"
  >
    <warehouse-detail-grid ref="detailGrid" :action="action" :context="context" :job="job" :warehouse-in="warehouse" :open-imperial="openImperial" />
    <div slot="footer" style="text-align: right; margin-top: 15px;">
      <el-button no="1" type="primary" @click="enterHandler">{{ $t('common.btn.ok') }} </el-button>
      <el-button no="2" @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import warehouseDetailGrid from './warehouseDetailGrid'
import { saveWarehouseInForAe } from '@/api/seaExport/warehouseIn'

export default {
  name: 'WarehouseInDetailDialog',
  components: {
    warehouseDetailGrid
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    job: {
      type: Object,
      required: true
    },
    warehouse: {
      type: Object,
      required: true
    },
    openImperial: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      innerVisible: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.detailGrid.fillView()
        })
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    closeHandler() {
      this.$emit('winClose')
      this.innerVisible = false
    },
    enterHandler() {
      const job = this.job
      const warehouse = this.warehouse
      if (!job.warehouseNo) {
        this.warehouse.warehouseNo = job.jobNo
        job.warehouseNo = job.jobNo
      } else {
        warehouse.warehouseNo = job.warehouseNo
      }
      warehouse.warehouseInDate = new Date()
      const warehouseInDetail = this.$refs.detailGrid.rowData
      for (const detail of warehouseInDetail) {
        detail.warehouseInUuid = warehouse.uuid
      }
      warehouse.jobUuid = job.uuid
      warehouse.warehouseInDetail = warehouseInDetail
      if (!warehouse.lob) {
        warehouse.lob = job.lob
      }
      saveWarehouseInForAe(warehouse).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('commit')
        this.innerVisible = false
      })
    }
  }
}
</script>

<style lang="scss">
</style>
